/*
  assets/hrc-diagnostic-app.js
  Controlador principal del Diagnostico HRC V1. No contiene preguntas,
  consejos, reglas de puntuacion ni productos (viven en sus propios modulos).

  CORRECCIONES DE ESTA AUDITORIA (ver informe para el detalle completo):
  P0-2 barra de progreso real; P0-4 espera activa del catalogo antes de
  recomendar + manejo de errores visible; P1-7 modo concentracion; P1-9
  reiniciar condicional + "Repetir diagnostico"; P1-10 navegacion Q1/Q25;
  P1-11 CTA pregunta opcional; P1-12 indicador de area; P2-18/19 PDF y copia
  por correo; P2-20 nota de rol del staff.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-hrc-d-root]');
    if (!root) return;

    var CONTENT = window.HRC_DIAGNOSTIC_CONTENT;
    var CFG = window.HRC_DIAGNOSTIC_CONFIG;
    var SCORING = window.HRC_DIAGNOSTIC_SCORING;
    var REPORT = window.HRC_DIAGNOSTIC_REPORT;
    var RECS = window.HRC_DIAGNOSTIC_RECOMMENDATIONS;
    var INTEGRATIONS = window.HRC_DIAGNOSTIC_INTEGRATIONS;
    var store = window.HRC_DIAGNOSTIC_STATE.createStore();

    var klaviyoListId = root.getAttribute('data-hrc-d-klaviyo-list-id') || '';

    // ---- Auditoria (2a ronda, motor de recomendaciones): trazado de depuracion --
    // Nunca visible al usuario final. Solo se activa con ?hrc_debug=1 en la
    // URL y solo escribe en consola (no hay UI ni panel). Desactivado por
    // defecto: sin el parametro, DEBUG es false y ninguna de las funciones
    // de abajo hace nada.
    var DEBUG = (function () {
      try { return new URLSearchParams(window.location.search).get('hrc_debug') === '1'; } catch (e) { return false; }
    })();

    // Pantallas donde se activa el "modo concentracion" (P1-7).
    var FOCUS_SCREENS = ['context', 'instructions', 'questions', 'optional'];

    // ---- Utilidades de pantalla --------------------------------------------
    function showScreen(name) {
      root.querySelectorAll('[data-hrc-d-screen]').forEach(function (s) {
        s.hidden = s.getAttribute('data-hrc-d-screen') !== name;
      });
      var target = root.querySelector('[data-hrc-d-screen="' + name + '"]');
      if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: false }); }
      var progressWrap = root.querySelector('[data-hrc-d-progress]');
      if (progressWrap) progressWrap.hidden = (name !== 'questions');
      document.body.classList.toggle('hrc-focus-mode', FOCUS_SCREENS.indexOf(name) !== -1);
      updateRestartVisibility(name);
      // Auditoria (conexion V1 a la pagina real): cada vez que se vuelve a
      // "welcome" (recarga, "Repetir diagnostico" desde el informe,
      // reinicio confirmado...) hay que recalcular si procede ofrecer
      // "Ver mi ultimo informe" -- ver updateWelcomeSavedState().
      if (name === 'welcome') updateWelcomeSavedState();
      store.setScreen(name);
    }

    function currentAreas() {
      var audience = store.getState().audience;
      return CONTENT.areas[audience === 'coach' ? 'coach' : 'player'];
    }

    function allQuestions() {
      var areas = currentAreas();
      return areas.reduce(function (acc, a, areaIndex) {
        return acc.concat(a.questions.map(function (q) { return { q: q, areaKey: a.key, areaLabel: a.label, areaIndex: areaIndex, areaCount: areas.length }; }));
      }, []);
    }

    // ---- P1-9: reiniciar condicional -----------------------------------------
    function updateRestartVisibility(screen) {
      var btn = root.querySelector('[data-hrc-d-restart]');
      if (!btn) return;
      if (screen === 'welcome' && !store.hasSavedProgress()) { btn.hidden = true; return; }
      if (screen === 'report') { btn.hidden = true; return; } // en informe se sustituye por "Repetir diagnostico".
      btn.hidden = false;
    }

    // ---- Pantalla: bienvenida ----------------------------------------------
    var startBtn = root.querySelector('[data-hrc-d-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        var state = store.getState();
        INTEGRATIONS.track('hrc_diagnostic_started', {});
        store.markStarted();
        if (store.hasSavedProgress()) {
          showRestoreConfirm();
        } else if (state.audience) {
          // BUG CORREGIDO: cuando ya hay audiencia guardada pero todavia no
          // hay ninguna respuesta (hasSavedProgress() es false), este
          // camino saltaba directo a la pantalla "context" sin volver a
          // pintar sus 4 campos -- el contenedor [data-hrc-d-context-fields]
          // solo se rellena dentro de renderContextForm(), que unicamente se
          // llamaba desde el click en "Soy jugador/entrenador". Resultado:
          // "Antes de empezar" se mostraba vacio (solo titulo + boton).
          renderContextForm(state.audience);
          showScreen('context');
        } else {
          showScreen('audience');
        }
      });
    }

    // ---- BUG CORREGIDO (conexion V1 a la pagina real): informe guardado ----
    // hasSavedProgress() excluye deliberadamente screen==='report' (asi
    // estaba disenado desde Fase 3: un informe terminado no es "progreso a
    // medias"). Efecto colateral no deseado: quien termina el diagnostico,
    // sale y vuelve a pulsar "Empezar diagnostico" perdia el acceso a su
    // informe -- se le mandaba a un formulario de contexto en blanco/nuevo
    // sin avisar. isValidSavedReport()/updateWelcomeSavedState() anaden una
    // via paralela, sin tocar hasSavedProgress() ni el flujo de "progreso a
    // medias" ya validado.
    function isValidSavedReport(state) {
      if (!state || state.screen !== 'report') return false;
      if (state.audience !== 'player' && state.audience !== 'coach') return false;
      var result = state.result;
      if (!result || typeof result !== 'object') return false;
      // Version incompatible del scoring: no se intenta renderizar.
      if (result.version !== CFG.versions.scoring) return false;
      if (!Array.isArray(result.areaScores) || result.areaScores.length !== 5) return false;
      if (!result.priority1 || typeof result.generalScore !== 'number') return false;
      if (!state.answers || Object.keys(state.answers).length === 0) return false;
      return true;
    }

    function updateWelcomeSavedState() {
      var savedWrap = root.querySelector('[data-hrc-d-welcome-saved]');
      if (!savedWrap) return;
      var state = store.getState();
      if (state.screen === 'report' && !isValidSavedReport(state)) {
        // Estado incompleto, corrupto o de una version incompatible del
        // cuestionario/scoring: se descarta de forma segura en vez de
        // intentar reconstruirlo.
        store.reset();
        state = store.getState();
      }
      var valid = isValidSavedReport(state);
      savedWrap.hidden = !valid;
      if (startBtn) startBtn.hidden = valid;
    }

    var viewSavedBtn = root.querySelector('[data-hrc-d-view-saved]');
    if (viewSavedBtn) {
      viewSavedBtn.addEventListener('click', function () {
        var state = store.getState();
        if (!isValidSavedReport(state)) { updateWelcomeSavedState(); return; }
        // "Ver mi ultimo informe": usa result/context ya guardados tal
        // cual -- no recalcula el resultado (computeResult() ni se llama),
        // no reenvia el formulario de lead, no repite el consentimiento y
        // no vuelve a disparar hrc_diagnostic_lead_submitted.
        renderReportFromResult(state.result, state);
      });
    }
    var restartFromWelcomeBtn = root.querySelector('[data-hrc-d-restart-from-welcome]');
    if (restartFromWelcomeBtn) {
      restartFromWelcomeBtn.addEventListener('click', function () {
        confirmRestart(function () {
          // store.reset() solo borra la clave de localStorage de este
          // diagnostico (hrc_diagnostic_v1_state) -- no toca ningun otro
          // dato de la tienda.
          store.reset();
          INTEGRATIONS.track('hrc_diagnostic_restarted', {});
          showScreen('audience');
        });
      });
    }

    function showRestoreConfirm() {
      var modal = root.querySelector('[data-hrc-d-restore-modal]');
      if (!modal) { showScreen(store.getState().audience ? 'questions' : 'audience'); return; }
      modal.hidden = false;
      modal.querySelector('[data-hrc-d-restore-continue]').focus();
    }
    var restoreModal = root.querySelector('[data-hrc-d-restore-modal]');
    if (restoreModal) {
      restoreModal.querySelector('[data-hrc-d-restore-continue]').addEventListener('click', function () {
        restoreModal.hidden = true;
        var state = store.getState();
        var target = state.screen && state.screen !== 'welcome' ? state.screen : 'questions';
        // Mismo bug, segundo camino: restaurar un progreso guardado cuya
        // ultima pantalla era "context" tampoco repintaba sus campos.
        if (target === 'context') renderContextForm(state.audience);
        showScreen(target);
        if (target === 'questions') renderQuestion();
        if (target === 'optional') renderOptionalQuestion();
      });
      restoreModal.querySelector('[data-hrc-d-restore-restart]').addEventListener('click', function () {
        restoreModal.hidden = true;
        confirmRestart(function () { store.reset(); showScreen('audience'); });
      });
    }

    // ---- Confirmacion antes de reiniciar (sin alert()) ---------------------
    function confirmRestart(onConfirm) {
      var modal = root.querySelector('[data-hrc-d-confirm-modal]');
      if (!modal) { onConfirm(); return; }
      modal.hidden = false;
      var yes = modal.querySelector('[data-hrc-d-confirm-yes]');
      var no = modal.querySelector('[data-hrc-d-confirm-no]');
      function cleanup() { modal.hidden = true; yes.removeEventListener('click', onYes); no.removeEventListener('click', onNo); }
      function onYes() { cleanup(); onConfirm(); }
      function onNo() { cleanup(); }
      yes.addEventListener('click', onYes);
      no.addEventListener('click', onNo);
      yes.focus();
    }
    var restartBtn = root.querySelector('[data-hrc-d-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        if (restartBtn.hidden) return;
        confirmRestart(function () {
          store.reset();
          INTEGRATIONS.track('hrc_diagnostic_restarted', {});
          showScreen('welcome');
        });
      });
    }
    var repeatBtn = root.querySelector('[data-hrc-d-repeat]');
    if (repeatBtn) {
      repeatBtn.addEventListener('click', function () {
        confirmRestart(function () {
          store.reset();
          INTEGRATIONS.track('hrc_diagnostic_restarted', {});
          showScreen('welcome');
        });
      });
    }

    // ---- Pantalla: audiencia -----------------------------------------------
    root.querySelectorAll('[data-hrc-d-audience]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var audience = btn.getAttribute('data-hrc-d-audience');
        store.setAudience(audience);
        INTEGRATIONS.track('hrc_diagnostic_audience_selected', { audience: audience });
        renderContextForm(audience);
        showScreen('context');
      });
    });

    // ---- Pantalla: contexto -------------------------------------------------
    function renderContextForm(audience) {
      var wrap = root.querySelector('[data-hrc-d-context-fields]');
      if (!wrap) return;
      var state = store.getState();
      var existing = state.context || {};
      wrap.innerHTML = '';
      var opts = CONTENT.contextOptions[audience === 'coach' ? 'coach' : 'player'];
      var fields = audience === 'coach'
        ? [['role', 'Tu función', opts.role], ['context', 'Contexto', opts.context], ['moment', 'Momento de la temporada', opts.moment], ['goal', 'Tu objetivo principal ahora mismo', opts.goal]]
        : [['position', 'Tu posición', opts.position], ['levelContext', 'Nivel / contexto', opts.levelContext], ['moment', 'Momento de la temporada', opts.moment], ['goal', 'Tu objetivo principal ahora mismo', opts.goal]];
      fields.forEach(function (f) {
        var key = f[0], label = f[1], options = f[2];
        var field = document.createElement('div');
        field.className = 'hrc-d__field';
        var labelEl = document.createElement('label');
        labelEl.setAttribute('for', 'hrc-d-ctx-' + key);
        labelEl.textContent = label;
        var select = document.createElement('select');
        select.id = 'hrc-d-ctx-' + key;
        select.setAttribute('data-hrc-d-context-field', key);
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Selecciona...';
        select.appendChild(placeholder);
        options.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o.value;
          opt.textContent = o.label;
          if (existing[key] === o.value) opt.selected = true;
          select.appendChild(opt);
        });
        field.appendChild(labelEl);
        field.appendChild(select);
        wrap.appendChild(field);
      });
    }

    var contextContinue = root.querySelector('[data-hrc-d-context-continue]');
    if (contextContinue) {
      contextContinue.addEventListener('click', function () {
        var context = {};
        root.querySelectorAll('[data-hrc-d-context-field]').forEach(function (f) {
          context[f.getAttribute('data-hrc-d-context-field')] = f.value;
        });
        store.setContext(context);
        INTEGRATIONS.track('hrc_diagnostic_context_completed', context);
        showScreen('instructions');
      });
    }

    // ---- Pantalla: instrucciones --------------------------------------------
    var instructionsContinue = root.querySelector('[data-hrc-d-instructions-continue]');
    if (instructionsContinue) {
      instructionsContinue.addEventListener('click', function () {
        var audience = store.getState().audience;
        root.querySelector('[data-hrc-d-instructions-text]').textContent = CONTENT.instructions[audience === 'coach' ? 'coach' : 'player'];
        showScreen('questions');
        renderQuestion();
      });
    }
    // P1-10: "Anterior" desde la pregunta 1 debe permitir volver a instrucciones.
    var instructionsFromQuestions = root.querySelector('[data-hrc-d-back-to-instructions]');

    // ---- Pantalla: preguntas (25, una por pantalla) -------------------------
    function updateProgress() {
      var fill = root.querySelector('[data-hrc-d-progress-fill]');
      var bar = root.querySelector('[data-hrc-d-progress-bar]');
      var text = root.querySelector('[data-hrc-d-progress-text]');
      var areaIndicator = root.querySelector('[data-hrc-d-area-indicator]');
      var total = allQuestions().length;
      var idx = store.getState().questionIndex;
      // P0-2: la barra debe reflejar "preguntas vistas hasta ahora, incluida
      // la actual" -- (idx+1)/total. Con idx en 0..24 esto da exactamente
      // 4/20/40/60/80/100% en las preguntas 1/5/10/15/20/25.
      var pct = Math.round(((idx + 1) / total) * 100);
      if (fill) fill.style.width = pct + '%';
      // P0-B (2a ronda): mantener aria-valuenow sincronizado con el relleno real.
      if (bar) bar.setAttribute('aria-valuenow', String(pct));
      if (text) text.textContent = 'Pregunta ' + (idx + 1) + ' de ' + total;
      var item = allQuestions()[idx];
      if (areaIndicator && item) areaIndicator.textContent = 'Área ' + (item.areaIndex + 1) + ' de ' + item.areaCount;
      if (pct === 25 || pct === 50 || pct === 75) INTEGRATIONS.track('hrc_diagnostic_progress_' + pct, { index: idx });
    }

    var lastRenderedAreaIndex = -1;
    function renderQuestion() {
      var qs = allQuestions();
      var idx = store.getState().questionIndex;
      var item = qs[idx];
      if (!item) { finishQuestions(); return; }
      var audience = store.getState().audience;
      var scale = CONTENT.scales[audience === 'coach' ? 'coach' : 'player'];

      root.querySelector('[data-hrc-d-question-area]').textContent = item.areaLabel;
      root.querySelector('[data-hrc-d-question-text]').textContent = item.q.text;

      var scaleWrap = root.querySelector('[data-hrc-d-scale]');
      scaleWrap.innerHTML = '';
      scaleWrap.setAttribute('role', 'radiogroup');
      scaleWrap.setAttribute('aria-label', item.q.text);
      var currentAnswer = store.getState().answers[item.q.id];
      scale.forEach(function (label, i) {
        var value = i + 1;
        var optLabel = document.createElement('label');
        optLabel.className = 'hrc-d-scale__opt';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = item.q.id;
        input.value = String(value);
        input.checked = currentAnswer === value;
        input.addEventListener('change', function () {
          store.setAnswer(item.q.id, value);
          root.querySelector('[data-hrc-d-next]').disabled = false;
        });
        var span = document.createElement('span');
        span.textContent = value + ' · ' + label;
        optLabel.appendChild(input);
        optLabel.appendChild(span);
        scaleWrap.appendChild(optLabel);
      });

      var prevButton = root.querySelector('[data-hrc-d-prev]');
      prevButton.disabled = false; // P1-10: en la pregunta 1 "Anterior" ya no se deshabilita, lleva a instrucciones.
      var nextButton = root.querySelector('[data-hrc-d-next]');
      nextButton.disabled = typeof currentAnswer !== 'number';
      // P1-10: renombrar "Siguiente" a "Finalizar preguntas" en la ultima.
      nextButton.textContent = (idx === qs.length - 1) ? 'Finalizar preguntas' : 'Siguiente →';

      updateProgress();
      lastRenderedAreaIndex = item.areaIndex;
    }

    var nextBtn = root.querySelector('[data-hrc-d-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var qs = allQuestions();
        var idx = store.getState().questionIndex;
        if (typeof store.getState().answers[qs[idx].q.id] !== 'number') return;
        if (idx < qs.length - 1) {
          store.setQuestionIndex(idx + 1);
          renderQuestion();
        } else {
          finishQuestions();
        }
      });
    }
    var prevBtn = root.querySelector('[data-hrc-d-prev]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var idx = store.getState().questionIndex;
        if (idx > 0) {
          store.setQuestionIndex(idx - 1);
          renderQuestion();
        } else {
          // P1-10: desde la pregunta 1, "Anterior" vuelve a instrucciones
          // conservando todo lo respondido (no se borra nada del estado).
          showScreen('instructions');
        }
      });
    }

    function finishQuestions() {
      store.markQuestionsCompleted();
      INTEGRATIONS.track('hrc_diagnostic_questions_completed', {});
      renderOptionalQuestion();
      showScreen('optional');
    }

    // ---- Pantalla: pregunta opcional -----------------------------------------
    function renderOptionalQuestion() {
      var audience = store.getState().audience;
      var opt = CONTENT.optionalQuestion[audience === 'coach' ? 'coach' : 'player'];
      var state = store.getState();
      root.querySelector('[data-hrc-d-optional-label]').textContent = opt.sectionLabel || 'Pregunta opcional';
      root.querySelector('[data-hrc-d-optional-helper]').textContent = opt.helperText || '';
      root.querySelector('[data-hrc-d-optional-text]').textContent = opt.text;
      var wrap = root.querySelector('[data-hrc-d-optional-options]');
      wrap.innerHTML = '';
      opt.options.forEach(function (o) {
        var label = document.createElement('label');
        label.className = 'hrc-d-scale__opt';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'hrc-d-optional';
        input.value = o.value;
        input.checked = state.perceivedLimitation === o.value;
        input.addEventListener('change', function () {
          var freeWrap = root.querySelector('[data-hrc-d-optional-free-wrap]');
          freeWrap.hidden = o.value !== 'otro';
        });
        var span = document.createElement('span');
        span.textContent = o.label;
        label.appendChild(input);
        label.appendChild(span);
        wrap.appendChild(label);
      });
      root.querySelector('[data-hrc-d-optional-free-label]').textContent = opt.freeTextLabel;
      // P1-11: el texto libre se conserva al retroceder (se restaura desde el estado).
      var freeInput = root.querySelector('[data-hrc-d-optional-free]');
      freeInput.value = state.perceivedLimitationText || '';
      root.querySelector('[data-hrc-d-optional-free-wrap]').hidden = state.perceivedLimitation !== 'otro';
    }

    var optionalContinue = root.querySelector('[data-hrc-d-optional-continue]');
    if (optionalContinue) {
      optionalContinue.addEventListener('click', function () {
        var checked = root.querySelector('input[name="hrc-d-optional"]:checked');
        // P1-11: "Otro" opcional de verdad -- no bloquea si el texto libre esta vacio.
        var freeText = root.querySelector('[data-hrc-d-optional-free]').value || '';
        store.setPerceivedLimitation(checked ? checked.value : null, freeText);
        computeAndShowTeaser();
      });
    }
    var optionalSkip = root.querySelector('[data-hrc-d-optional-skip]');
    if (optionalSkip) {
      optionalSkip.addEventListener('click', function () {
        store.setPerceivedLimitation(null, '');
        computeAndShowTeaser();
      });
    }
    var optionalBack = root.querySelector('[data-hrc-d-optional-back]');
    if (optionalBack) {
      optionalBack.addEventListener('click', function () {
        store.setQuestionIndex(allQuestions().length - 1);
        showScreen('questions');
        renderQuestion();
      });
    }

    // ---- Calculo + teaser -----------------------------------------------------
    function computeResult() {
      var state = store.getState();
      var areas = currentAreas();
      var result = SCORING.computeFullResult({
        audience: state.audience,
        areas: areas,
        answers: state.answers,
        goal: state.context.goal,
        perceivedLimitation: state.perceivedLimitation,
        freeText: state.perceivedLimitationText,
        elapsedSeconds: store.elapsedSeconds()
      });
      store.setResult(result);
      return result;
    }

    function computeAndShowTeaser() {
      var result = computeResult();
      root.querySelector('[data-hrc-d-teaser-priority]').textContent = result.priority1.label;
      root.querySelector('[data-hrc-d-teaser-text]').textContent = 'Tu área con más margen de mejora ahora mismo es "' + result.priority1.label + '". Tu informe completo incluye tu puntuación por área, un patrón de aprendizaje, cinco miniconsejos y tres acciones concretas para esta semana.';
      INTEGRATIONS.track('hrc_diagnostic_teaser_viewed', { priority1: result.priority1.key });
      showScreen('teaser');
    }

    var teaserContinue = root.querySelector('[data-hrc-d-teaser-continue]');
    if (teaserContinue) {
      teaserContinue.addEventListener('click', function () { showScreen('lead'); });
    }

    // ---- Pantalla: nombre, email, consentimientos ----------------------------
    var leadForm = root.querySelector('[data-hrc-d-lead-form]');
    if (leadForm) {
      leadForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = root.querySelector('#hrc-d-name').value.trim();
        var email = root.querySelector('#hrc-d-email').value.trim();
        var consentRequired = root.querySelector('[data-hrc-d-consent-required]').checked;
        var consentMarketing = root.querySelector('[data-hrc-d-consent-marketing]').checked;
        if (!name || !email || !consentRequired) return;
        store.setLeadField('name', name);
        store.setLeadField('email', email);
        store.setLeadField('consentRequired', consentRequired);
        store.setLeadField('consentMarketing', consentMarketing);

        var state = store.getState();
        var payload = {
          name: name, email: email, audience: state.audience, context: state.context,
          answers: state.answers, result: state.result,
          consentRequired: consentRequired, consentMarketing: consentMarketing,
          timestamp: new Date().toISOString(), source: CFG.source,
          versions: { scoring: CFG.versions.scoring, content: CONTENT.versions[state.audience === 'coach' ? 'coach' : 'player'] }
        };
        INTEGRATIONS.submitLead(payload, klaviyoListId);
        INTEGRATIONS.track('hrc_diagnostic_lead_submitted', { audience: state.audience });

        showReport();
      });
    }

    // ---- P0-4: espera activa del catalogo antes de recomendar -----------------
    function debugCatalogState(label, data) {
      if (!DEBUG) return;
      console.log('[HRC_DEBUG] catalogo (' + label + ')', {
        hasHRC: typeof window.HRC !== 'undefined',
        hasCatalogDataV2: !!(window.HRC && ('catalogDataV2' in window.HRC)),
        type: Object.prototype.toString.call(data),
        isArray: Array.isArray(data),
        length: Array.isArray(data) ? data.length : null,
        firstProductSample: Array.isArray(data) && data[0] ? { id: data[0].id, title: data[0].title, diagnosticEnabled: data[0].diagnosticEnabled, audiences: data[0].audiences } : null,
        timestamp: new Date().toISOString()
      });
    }
    function waitForCatalog(callback) {
      if (window.HRC && Array.isArray(window.HRC.catalogDataV2) && window.HRC.catalogDataV2.length > 0) {
        debugCatalogState('ya_disponible_sin_esperar', window.HRC.catalogDataV2);
        callback(window.HRC.catalogDataV2);
        return;
      }
      debugCatalogState('no_disponible_aun_esperando_evento', window.HRC && window.HRC.catalogDataV2);
      var settled = false;
      function onReady(e) {
        if (settled) return;
        settled = true;
        document.removeEventListener('hrc:catalog-v2-ready', onReady);
        var data = (e && e.detail && e.detail.data) || (window.HRC && window.HRC.catalogDataV2) || [];
        debugCatalogState('evento_hrc_catalog_v2_ready_recibido', data);
        callback(data);
      }
      document.addEventListener('hrc:catalog-v2-ready', onReady);
      // Salvaguarda: si el evento ya se disparo antes de registrar el
      // listener (orden de carga), no esperar indefinidamente.
      setTimeout(function () {
        if (settled) return;
        settled = true;
        document.removeEventListener('hrc:catalog-v2-ready', onReady);
        var data = (window.HRC && window.HRC.catalogDataV2) || [];
        debugCatalogState('timeout_1500ms_sin_evento', data);
        callback(data);
      }, 1500);
    }

    // ---- Pantalla: informe ------------------------------------------------
    // P0-C (2a ronda): se conserva el ultimo result/recs/state/extras
    // renderizados para poder generar el PDF independiente (HRC_DIAGNOSTIC_PRINT)
    // sin tener que recalcular ni releer el DOM del informe.
    var lastReportPayload = null;
    // Auditoria (conexion V1 a la pagina real): extraido de showReport()
    // para poder reutilizarlo tal cual desde "Ver mi ultimo informe"
    // (result/state ya guardados, sin recalcular ni releer el formulario).
    function renderReportFromResult(result, state) {
      waitForCatalog(function (catalogData) {
        try {
          var recs = RECS.recommend(catalogData, result, state.context);
          if (DEBUG) {
            console.log('[HRC_DEBUG] trazado completo del motor de recomendaciones', {
              input: {
                audience: state.audience,
                normalizedAudience: state.audience === 'coach' ? 'trainer' : state.audience,
                position: state.context.position || null,
                seasonMoment: state.context.moment || null,
                role: state.context.role || null,
                level: result.generalLevel.key,
                priority1: result.priority1.key,
                priority2: result.priority2 ? result.priority2.key : null,
                strongestAreas: (result.strongestAreas || []).map(function (a) { return a.key; })
              },
              catalogReady: Array.isArray(catalogData) && catalogData.length > 0,
              catalogSize: recs.catalogSize,
              candidates: recs._debug,
              selected: {
                freeResource: recs.free ? recs.free.title : null,
                primaryProduct: recs.main ? recs.main.title : null,
                complementaryProduct: recs.complement ? recs.complement.title : null
              }
            });
          }
          var roleNote = state.audience === 'coach' ? (CONTENT.roleNotes[state.context.role] || null) : null;
          var extras = {
            contrastText: CONTENT.contrastText[state.audience === 'coach' ? 'coach' : 'player'],
            bottleneckExplanation: (CONTENT.bottleneckExplanations[state.audience === 'coach' ? 'coach' : 'player'] || {})[result.bottleneck.layer],
            roleNote: roleNote,
            contextOptions: CONTENT.contextOptions[state.audience === 'coach' ? 'coach' : 'player']
          };
          var reportRoot = root.querySelector('[data-hrc-d-screen="report"]');
          REPORT.render(reportRoot, result, recs, state, extras);
          lastReportPayload = { result: result, recommendations: recs, state: state, extras: extras, pagePath: window.location.pathname };
          INTEGRATIONS.track('hrc_diagnostic_report_viewed', { priority1: result.priority1.key, generalScore: result.generalScore });
          showScreen('report');
        } catch (err) {
          // El informe NUNCA debe quedar en blanco sin explicacion: si algo
          // falla, se registra en consola (diagnosticable) y se muestra el
          // informe igualmente con lo que si se pudo calcular.
          console.error('[HRC Diagnostico] Error al construir el informe:', err);
          INTEGRATIONS.track('hrc_diagnostic_error', { message: String(err && err.message) });
          try {
            // catalogEmpty:true aqui es deliberado -- este camino solo se
            // alcanza cuando algo lanzo una excepcion real (motor de
            // recomendaciones o render), no cuando simplemente no hubo
            // candidato compatible. El informe debe decirlo con el mensaje
            // de fallo tecnico, no con el de "no hay recurso compatible".
            var fallbackRecs = { free: null, main: null, complement: null, upcoming: null, hasMatch: false, catalogEmpty: true, catalogSize: 0 };
            var fallbackExtras = {
              contrastText: CONTENT.contrastText[state.audience === 'coach' ? 'coach' : 'player'],
              bottleneckExplanation: null,
              roleNote: null,
              contextOptions: CONTENT.contextOptions[state.audience === 'coach' ? 'coach' : 'player']
            };
            var reportRootFallback = root.querySelector('[data-hrc-d-screen="report"]');
            REPORT.render(reportRootFallback, result, fallbackRecs, state, fallbackExtras);
            lastReportPayload = { result: result, recommendations: fallbackRecs, state: state, extras: fallbackExtras, pagePath: window.location.pathname };
          } catch (err2) { console.error('[HRC Diagnostico] Error incluso en el informe de respaldo:', err2); }
          showScreen('report');
        }
      });
    }

    function showReport() {
      var state = store.getState();
      var result = state.result || computeResult();
      renderReportFromResult(result, state);
    }

    // ---- P0-C (2a ronda): PDF profesional independiente, no captura de pantalla ----
    // Se retira window.print() de la pagina viva (producia menu, barra
    // promocional y fondo oscuro). HRC_DIAGNOSTIC_PRINT construye un
    // documento HTML aislado en una pestana nueva a partir de
    // lastReportPayload y solo imprime esa pestana: cancelar el dialogo de
    // impresion no navega ni borra el progreso de esta pagina.
    var pdfBtn = root.querySelector('[data-hrc-d-download-pdf]');
    if (pdfBtn) {
      pdfBtn.addEventListener('click', function () {
        INTEGRATIONS.track('hrc_diagnostic_product_viewed', { action: 'pdf_download' });
        if (!lastReportPayload || !window.HRC_DIAGNOSTIC_PRINT) {
          console.error('[HRC Diagnostico] No hay informe calculado todavia para generar el PDF.');
          return;
        }
        var opened = window.HRC_DIAGNOSTIC_PRINT.openAndPrint(lastReportPayload);
        if (!opened || !opened.opened) {
          console.error('[HRC Diagnostico] El navegador bloqueo la ventana emergente del PDF.');
        }
      });
    }

    // ---- P2-19: copia por correo (adaptador, sin endpoint inventado) ---------
    var emailCopyBtn = root.querySelector('[data-hrc-d-email-copy]');
    if (emailCopyBtn) {
      emailCopyBtn.addEventListener('click', function () {
        var statusEl = root.querySelector('[data-hrc-d-email-copy-status]');
        var state = store.getState();
        INTEGRATIONS.submitLead({
          type: 'resend_copy', email: state.lead.email, timestamp: new Date().toISOString(), source: CFG.source
        }, klaviyoListId);
        if (statusEl) {
          statusEl.hidden = false;
          statusEl.textContent = 'Hemos guardado tu solicitud. El envío automático por correo está pendiente de configurar (integración server-side) — mientras tanto, descarga tu informe en PDF, que sí está disponible ahora mismo.';
        }
      });
    }

    // Auditoria (conexion V1 a la pagina real): la pantalla "welcome" es
    // visible por defecto en el HTML (no pasa por showScreen() en la carga
    // inicial), asi que esta llamada unica al arrancar es la que decide si
    // se muestra "Empezar diagnostico" o "Ver mi ultimo informe / Repetir
    // diagnostico" la primera vez que se abre la pagina.
    updateWelcomeSavedState();
  });
})();
